module.exports = __webpack_public_path__ + "static/img/98028A_3_4_C_20240430_fit.fe66ed0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/98028A_3_4_C_20240430_fit.png
// module id = 8Ig5
// module chunks = 0